module.exports = __webpack_public_path__ + "static/media/face-6.08ced048.jpeg";